// A labelled panel in the comparison control row: a small muted caption above
// whatever control it wraps (View, Adjust, Opacity, Previous, Current…).
//
// `panel` draws the bordered frame the control row groups its sections with.
const ControlGroup = ({ caption, panel, className = "", children }) => (
  <span
    className={[
      "compare-control-group",
      panel ? "compare-panel" : "",
      className,
    ]
      .filter(Boolean)
      .join(" ")}
  >
    {caption ? (
      <span className="compare-control-caption">{caption}</span>
    ) : null}
    {children}
  </span>
);

export default ControlGroup;
